<template>
  <v-dialog
    content-class="dialog-fixed-top"
    :value="isVisible"
    @input="v => v || $dismiss()"
    max-width="700">

    <OLoading :value="isLoading"/>

    <v-card v-if="!isLoading">
      <v-tabs v-model="currentTab"
        background-color="grey lighten-2">
        <v-tab href="#1">Geral</v-tab>
        <v-tab href="#2">JSON</v-tab>
        <v-tab href="#3">Payload Diff</v-tab>

        <v-tab-item value="1">
          <v-card-text class="pa-3">
            <v-row wrap class="ma-0">
              <v-col cols="6" class="cap-cont pa-3">
                <label>ID</label>
                <p>{{row._id}}</p>
              </v-col>
              <v-col cols="6" class="cap-cont pa-3">
                <label>Timestamp</label>
                <p>{{row.timestamp | moment}}</p>
              </v-col>
              <v-col cols="6" class="cap-cont pa-3">
                <label>Organização</label>
                <p>{{row.orgCode}}</p>
              </v-col>
              <v-col cols="6" class="cap-cont pa-3">
                <label>Login</label>
                <p>{{row.login}}</p>
              </v-col>
              <v-col cols="4" class="cap-cont pa-3">
                <label>Ação</label>
                <p>
                  <span class="tag">{{row.action}}</span>
                </p>
              </v-col>
              <v-col cols="4" class="cap-cont pa-3">
                <label>Objeto</label>
                <p><span class="tag">{{row.subjectType}} #{{row.subjectId}}</span></p>
              </v-col>
              <v-col cols="4" class="cap-cont pa-3">
                <label>Label</label>
                <p>{{row.label}}</p>
              </v-col>
              <v-col cols="12" v-if="row.comments != null"
                class="cap-cont pa-3">
                <label>Comentários</label>
                <p>{{row.comments}}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="2">
          <v-card-text class="pa-4 maxh-5">
            <pre>{{row | prettyJson}}</pre>
          </v-card-text>
        </v-tab-item>

        <v-tab-item value="3">
          <v-card-text class="pa-4 maxh-5">
            <JsonDiff :payload="row.payload"/>
          </v-card-text>
        </v-tab-item>

      </v-tabs>
    </v-card>
  </v-dialog>
</template>

<script>
import {go} from '@/models'

const fetchRecordDetails = id => go('get', '/paperman/history/' + id)

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {
    OLoading: require('oderon-vue/cpts/OLoading').default,
    JsonDiff: require('./JsonDiff').default,
  },
  data() {
    return {
      isLoading: true,
      currentTab: '1',
      row: null,
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.currentTab = '1'
      this.$loading(() => this.fetchData())
      return this.$open()
    },
    async fetchData() {
      this.row = await fetchRecordDetails(this.id)
    },
  }
}
</script>

<style>
</style>
